import { Pipe, PipeTransform } from '@angular/core';
import { SidebarItem } from '../../../../../core/components/layout/sidebar/contract/sidebar-item.contract';
import { PanelMenuModel } from '../contract/panel-menu-model.contract';

@Pipe({
  name: 'panelMenuBadge',
  standalone: true,
  pure: false,
})
export class PanelMenuBadgePipe implements PipeTransform {
  transform(value: PanelMenuModel): PanelMenuModel {
    (value || []).forEach((item) => {
      const sidebarItem = item as SidebarItem;
      if (sidebarItem.badgeValue && sidebarItem.badgeValue > 0) {
        this.createAndAppendBadgeToMenuItem(sidebarItem);
      }

      // children
      if (sidebarItem.items && sidebarItem.items.length) {
        sidebarItem.items.forEach((child) => {
          if (child.badgeValue && child.badgeValue > 0 && child.label) {
            this.createAndAppendBadgeToMenuItem(child);
          }
        });
      }
    });

    return value;
  }

  private createAndAppendBadgeToMenuItem(item: SidebarItem): void {
    setTimeout(() => {
      try {
        const textEl = this.findMenuItemByLabel(item.label);
        if (!textEl) return;

        const anchorEl = textEl.closest('a') as HTMLElement | null;
        if (!anchorEl) return;

        // If a badge already exists, update it and do not append another
        const existingBadge = anchorEl.querySelector('.custom-badge') as HTMLElement | null;
        if (existingBadge) {
          existingBadge.textContent = String(item.badgeValue ?? '');
          anchorEl.classList.add('has-badge');
          return;
        }

        const badgeEl = this.createBadgeElement(item.badgeValue);
        anchorEl.appendChild(badgeEl);
        anchorEl.classList.add('has-badge');
      } catch (e) {
        console.error('Failed to append badge to menu item', e);
      }
    });
  }

  private findMenuItemByLabel(label?: string): HTMLElement | undefined {
    const textNodes = Array.from(document.querySelectorAll('.p-panelmenu .p-menuitem-text')) as HTMLElement[];
    return textNodes.find((el) => el.textContent?.trim() === label?.trim());
  }

  private createBadgeElement(badgeValue?: number): HTMLSpanElement {
    const badgeEl = document.createElement('span');
    badgeEl.innerText = String(badgeValue);
    badgeEl.classList.add('custom-badge');

    const valueHasMoreThanOneDigit = badgeValue && badgeValue > 9;
    if (valueHasMoreThanOneDigit) {
      badgeEl.classList.add('custom-badge-with-length-bigger-than-one');
    } else {
      badgeEl.classList.remove('custom-badge-with-length-bigger-than-one');
    }

    return badgeEl;
  }
}
